"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BreakPoints = {
    'SMALL': 375,
    'MEDIUM': 768,
    'LARGE': 1024,
};
//# sourceMappingURL=styles.js.map